<div>
  <app-alert-box *ngIf="contactDetails"
                 [title]="'policy-lookup-customer-contact-info' | translate"
                 [type]="'warning'">
    <div class="details">{{contactDetails}}</div>
  </app-alert-box>
</div>
